// Booking utility functions

import { ADVANCE_PAYMENT_PERCENTAGE } from '../constants/bookingConstants';

export const formatPrice = (price) => {
  if (typeof price === 'number') {
    return `₹${price.toLocaleString('en-IN')}`;
  }
  if (typeof price === 'string' && price.includes('₹')) {
    return price;
  }
  return `₹${parseInt(price || 0).toLocaleString('en-IN')}`;
};

export const calculateAdvanceAmount = (totalPrice) => {
  const numericPrice = typeof totalPrice === 'number' ? totalPrice : parseInt(totalPrice.replace(/₹|,/g, '') || 0);
  return Math.floor(numericPrice * ADVANCE_PAYMENT_PERCENTAGE);
};

export const getTodayDate = () => {
  return new Date().toISOString().split('T')[0];
};

export const getBookingBreadcrumb = (servicePage = 'wedding-services') => {
  const servicePageMapping = {
    'most-booked-services': { label: 'Most Booked Services', page: 'most-booked-services' },
    'new-services': { label: 'New Services', page: 'new-services' },
    'wedding-services': { label: 'Wedding Services', page: 'wedding-services' },
    'default': { label: 'Services', page: 'wedding-services' }
  };

  const servicePageInfo = servicePageMapping[servicePage] || servicePageMapping['default'];

  return [
    { label: 'Home', page: 'home' },
    { label: servicePageInfo.label, page: servicePageInfo.page },
    { label: 'Book Service', page: null }
  ];
};

export const createDefaultBookingData = (serviceData = null) => {
  if (serviceData) {
    return {
      service: serviceData,
      package: serviceData.packages?.[0] || { name: 'Standard Package', price: serviceData.price || 0 },
      addOns: [],
      totalPrice: serviceData.price || 0
    };
  }
  
  return {
    service: {
      id: null,
      title: "Service Not Available",
      price: 0,
      duration: "N/A",
      image: "🔧"
    },
    package: {
      name: "No Package Selected",
      price: 0
    },
    addOns: [],
    totalPrice: 0
  };
};
